<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

import 'vue-select/dist/vue-select.css';
export default {
  name: 'App',
  created(){
    
  }
}
</script> 